import * as i from 'types';
import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';

export const defaultState: i.FormState = {
  household: '',
  water: '',
  questions: {},
  possessions: [],
  selectedTips: [],
  waterMeterReading: {
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    six: '',
    seven: '',
    eight: '',
  },
};

export type FormContextProps = {
  data: i.FormState;
  updateData: (newData: Partial<i.FormState>) => void;
  resetData: () => void;
};

export const FormContext = createContext<FormContextProps>({
  data: defaultState,
  updateData: () => undefined,
  resetData: () => undefined,
});

export type FormProviderProps = React.FC<{
  children: React.ReactNode;
}>;

export const FormProvider: FormProviderProps = ({ children }) => {
  const [data, setData] = useState(defaultState);

  const updateData = (newData: Partial<i.FormState>) => {
    try {
      setData({ ...data, ...newData });
    } catch (error) {
      console.error('Error updating form data:', error);
      toast.error('Er ging iets mis bij het bijwerken van de formuliergegevens');
    }
  };

  const resetData = () => {
    try {
      setData(defaultState);
    } catch (error) {
      console.error('Error resetting form data:', error);
      toast.error('Er ging iets mis bij het resetten van de formuliergegevens');
    }
  };

  return (
    <FormContext.Provider value={{ data, updateData, resetData }}>
      {children}
    </FormContext.Provider>
  );
};
